// extracted by mini-css-extract-plugin
export default {"alert":"Alerts_alert__+cgfn","fadeIn":"Alerts_fadeIn__ACVff","fadeOut":"Alerts_fadeOut__rKJv6","close":"Alerts_close__mmEFp","description":"Alerts_description__LpQWi"};